<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__table}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:table:save')" type="primary" @click="addOrUpdateHandle()">{{
              $t('add')
            }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:table:delete')" type="danger" @click="deleteHandle()">
            {{ $t('deleteBatch') }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="showGroupDialog()">分组管理</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"
                style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="groupName" label="所属分组" header-align="center" align="center"></el-table-column>
        <el-table-column prop="name" label="列表名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="useKey" label="引用键值" header-align="center" align="center"></el-table-column>
        <el-table-column prop="url" label="接口地址" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small"
                       @click="showDeailDialog(scope.row)">列设计
            </el-button>
            <el-button v-if="$hasPermission('sys:table:update')" type="text" size="small"
                       @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
            </el-button>
            <el-button v-if="$hasPermission('sys:table:delete')" type="text" size="small"
                       @click="deleteHandle(scope.row.id)">{{ $t('delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

        <el-pagination
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="limit"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="pageSizeChangeHandle"
            @current-change="pageCurrentChangeHandle">
        </el-pagination>

      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      <group-dialog ref="GroupDialog"></group-dialog>
      <table-detail-dialog ref="TableDetailDialog"></table-detail-dialog>
    </div>
  </el-card>
</template>

<script>
import GroupDialog from './group'
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './add-or-update'
import TableDetailDialog from './detail/index.vue'

export default {
  mixins: [mixinViewModule],
  components: {
    AddOrUpdate, GroupDialog,TableDetailDialog
  },
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/table/page',
        getDataListIsPage: true,
        exportURL: '/sys/table/export',
        deleteURL: '/sys/table',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  methods: {
    showDeailDialog(row){
      this.$refs.TableDetailDialog.tableName=row.name
      this.$refs.TableDetailDialog.tableId=row.id
      this.$refs.TableDetailDialog.init()
    },
    showGroupDialog () {
      this.$refs.GroupDialog.init()
    }
  }
}
</script>
